/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const Rectangle = styled('span')`
  display: inline-block;
  border-radius: ${theme.borderRadius.medium};
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background-color: ${theme.color.grayDark};
  opacity: ${({ opacity }) => opacity || 1};
`;

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 8px;
`;
